(function () {
  var END = Date.parse('2026-09-04T00:00:00+05:30');

  function hideEnded() {
    if (!END || Date.now() < END) return;
    document.querySelectorAll('[data-habba-end]').forEach(function (el) {
      el.classList.add('is-ended');
    });
  }

  hideEnded();
  document.addEventListener('shopify:section:load', hideEnded);
})();
